/** Overrides MUI default primary blue on listing / booking actions. */
export function listingContainedButtonSx(background, text, extra = {}) {
  return {
    backgroundColor: background,
    color: text,
    boxShadow: 'none',
    '&.MuiButton-containedPrimary': {
      backgroundColor: background,
      color: text,
    },
    '&:hover': {
      backgroundColor: background,
      color: text,
      opacity: 0.9,
      boxShadow: 'none',
    },
    ...extra,
  };
}

export function listingOutlinedButtonSx(background, extra = {}) {
  return {
    borderColor: background,
    color: background,
    backgroundColor: 'transparent',
    '&.MuiButton-outlinedPrimary': {
      borderColor: background,
      color: background,
    },
    '&:hover': {
      borderColor: background,
      color: background,
      backgroundColor: 'transparent',
      opacity: 0.85,
    },
    ...extra,
  };
}
